module.exports = __webpack_public_path__ + "img/emptystate-log-forms.2a7061d3.svg";